var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:collection",
    clipPath: "url(#clip0_72_3390)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 11C7.10218 11 6.72064 10.842 6.43934 10.5607C6.15804 10.2794 6 9.89782 6 9.5C6 9.10218 6.15804 8.72064 6.43934 8.43934C6.72064 8.15804 7.10218 8 7.5 8H40.5C40.8978 8 41.2794 8.15804 41.5607 8.43934C41.842 8.72064 42 9.10218 42 9.5C42 9.89782 41.842 10.2794 41.5607 10.5607C41.2794 10.842 40.8978 11 40.5 11H7.5ZM13.5 5C13.1022 5 12.7206 4.84196 12.4393 4.56066C12.158 4.27936 12 3.89782 12 3.5C12 3.10218 12.158 2.72064 12.4393 2.43934C12.7206 2.15804 13.1022 2 13.5 2H34.5C34.8978 2 35.2794 2.15804 35.5607 2.43934C35.842 2.72064 36 3.10218 36 3.5C36 3.89782 35.842 4.27936 35.5607 4.56066C35.2794 4.84196 34.8978 5 34.5 5H13.5ZM0 39.5C0 40.6935 0.474106 41.8381 1.31802 42.682C2.16193 43.5259 3.30653 44 4.5 44H43.5C44.6935 44 45.8381 43.5259 46.682 42.682C47.5259 41.8381 48 40.6935 48 39.5V18.5C48 17.3065 47.5259 16.1619 46.682 15.318C45.8381 14.4741 44.6935 14 43.5 14H4.5C3.30653 14 2.16193 14.4741 1.31802 15.318C0.474106 16.1619 0 17.3065 0 18.5L0 39.5ZM4.5 41C4.10218 41 3.72064 40.842 3.43934 40.5607C3.15804 40.2794 3 39.8978 3 39.5V18.5C3 18.1022 3.15804 17.7206 3.43934 17.4393C3.72064 17.158 4.10218 17 4.5 17H43.5C43.8978 17 44.2794 17.158 44.5607 17.4393C44.842 17.7206 45 18.1022 45 18.5V39.5C45 39.8978 44.842 40.2794 44.5607 40.5607C44.2794 40.842 43.8978 41 43.5 41H4.5Z",
    fill: "#FDF9FD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_3390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionIcon);
export default __webpack_public_path__ + "static/media/collectionIcon.92dbfba532a97a2db886216a123e0e9f.svg";
export { ForwardRef as ReactComponent };